var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false } },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  attrs: { layout: "inline" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchQuery.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "单据编号",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入单据编号" },
                                model: {
                                  value: _vm.queryParam.billNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParam, "billNo", $$v)
                                  },
                                  expression: "queryParam.billNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 6, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "流程类型",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: {
                                    placeholder: "请选择流程类型",
                                    "allow-clear": "",
                                  },
                                  model: {
                                    value: _vm.queryParam.billType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "billType", $$v)
                                    },
                                    expression: "queryParam.billType",
                                  },
                                },
                                _vm._l(_vm.billTypes, function (n, k) {
                                  return _c(
                                    "a-select-option",
                                    { key: k, attrs: { value: k } },
                                    [_vm._v(_vm._s(n))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "table-page-search-submitButtons",
                          staticStyle: { float: "left", overflow: "hidden" },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.searchQuery },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.searchReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              rowKey: "taskId",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              loading: _vm.loading,
              pagination: _vm.pagination,
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "billType",
                fn: function (text) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(_vm.billTypeName(text)) + "\n      "
                    ),
                  ]
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openApprove(record)
                          },
                        },
                      },
                      [_vm._v("审批")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "审批处理",
            visible: _vm.approveVisible,
            confirmLoading: _vm.approveLoading,
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.approveVisible = false
            },
          },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.approveVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "a-button",
                {
                  attrs: { type: "danger", loading: _vm.approveLoading },
                  on: {
                    click: function ($event) {
                      return _vm.doApprove("驳回")
                    },
                  },
                },
                [_vm._v("驳回")]
              ),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.approveLoading },
                  on: {
                    click: function ($event) {
                      return _vm.doApprove("通过")
                    },
                  },
                },
                [_vm._v("通过")]
              ),
            ],
            1
          ),
          _c(
            "a-descriptions",
            { attrs: { column: 1, size: "small" } },
            [
              _c("a-descriptions-item", { attrs: { label: "单据类型" } }, [
                _vm._v(_vm._s(_vm.billTypeName(_vm.current.billType))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "单据编号" } }, [
                _vm._v(_vm._s(_vm.current.billNo)),
              ]),
              _c("a-descriptions-item", { attrs: { label: "当前节点" } }, [
                _vm._v(_vm._s(_vm.current.nodeName)),
              ]),
            ],
            1
          ),
          _c("a-textarea", {
            staticStyle: { "margin-top": "12px" },
            attrs: { rows: 3, placeholder: "请输入审批意见" },
            model: {
              value: _vm.comment,
              callback: function ($$v) {
                _vm.comment = $$v
              },
              expression: "comment",
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }